export enum SortType {
  NEWEST_AT_TOP = "NEWEST_AT_TOP",
  OLDEST_AT_TOP = "OLDEST_AT_TOP",
}
